/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import rest from '../../../../client/js/lib/rest'
import { useQuery } from '@tanstack/react-query'
import { Modal, ModalProps, Text } from '@mantine/core'

async function fetchAppChangelog () {
  const resp = await rest.get('/api/app/changelog.md')
  return await resp.text()
}

function VersionNotesModal (props: ModalProps) {
  const { opened, ...others } = props
  const intl = useIntl()

  const changelogQuery = useQuery({
    enabled: opened,
    queryKey: ['changelog'],
    queryFn: () => fetchAppChangelog()
  })

  return (
    <Modal
      centered
      opened={opened}
      size="xl"
      title={intl.formatMessage({
        id: 'version_notes',
        defaultMessage: 'Notes de version'
      })}
      withinPortal
      {...others}
    >
      <Text
        bg="gray.0"
        p="lg"
        style={{ whiteSpace: 'pre-wrap' }}
      >
        {changelogQuery.data}
      </Text>
    </Modal>
  )
}

export default VersionNotesModal
